import { useEffect, useState } from 'react';
import Nav from '../../../shared/components/Nav';
import { MENU_CUSTOMER_SERVICE_CENTER } from '../../../shared/constants/app';
import { updateMenuVisibility } from '../../../utils';
import { getPAGAA000 } from '../../../services/Api';

const PAHAG010 = () => {
    const [customerServiceMenu, setCustomerServiceMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedCustomerServiceMenu = updateMenuVisibility(data, MENU_CUSTOMER_SERVICE_CENTER);
                setCustomerServiceMenu(updatedCustomerServiceMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    return (
        <div id="content">
            <Nav menu={customerServiceMenu} />
            <div id="notification" style={{ marginTop: 39 }}>
                <div className="container">
                    <div className="section-wrapper">
                        <div className="left-item">
                            <div className="header-frame">
                                <div className="titleText">사이트 소개</div>
                            </div>
                            <div className="sitro">
                                <div className="sitro__inner">
                                    <div className="sitro__top">
                                        <h3>
                                            <span>대한민국 치과계 No.1</span>
                                            구인 구직 네트워크
                                            <img src="./images/new-logo.png" alt="new logo" />
                                        </h3>
                                        <p>
                                            치과인을 위한 전문 정보 사이트{' '}
                                            <img src="./images/new-logo.png" alt="new logo" />은 21세기형 채용문화를
                                            선도하고자 기존의 구인, 구직 방식에서 탈피하여 보다 발전적이고 체계적인
                                            <br />
                                            온라인&nbsp;채용 시스템을 구축하고 고객 중심의 차별화된 서비스를
                                            실현함으로써 명실상부한 <span>치과계 최대의 전문 구인구직 토탈 사이트</span>
                                            로 자리잡고 있습니다.
                                        </p>
                                    </div>
                                    <ul className="sitro__list">
                                        <li className="sitro__item">
                                            <div className="sitro__sbj">
                                                <span className="sitro__num">1</span>
                                                <span className="sitro__stg">치과계의 No.1</span>
                                                &nbsp;구인구직 사이트
                                            </div>
                                            <div className="sitro__desc">
                                                <img src="./images/new-logo.png" alt="new logo" /> 은 치과위생사와
                                                치과기공사, 간호조무사 등 철저히 치과인을 위한 구인구직 사이트로서 현재{' '}
                                                <span>회원수 10만명 이상, 하루 평균 1,000여 명 이상의 방문자수</span>{' '}
                                                그리고 <span>하루 평균 5,000여 건의 접속 횟수</span>를 자랑하는 치과계
                                                No.1 구인구직 사이트 입니다. 또한 지역별, 역세권별, 직종별, 채용형태별로
                                                다양한 검색을 통하여 한차원 높은 구인구직 맞춤 정보를 제공하고 있습니다.
                                            </div>
                                        </li>
                                        <li className="sitro__item">
                                            <div className="sitro__sbj">
                                                <span className="sitro__num">2</span>
                                                <span className="sitro__stg">고객중심</span>의 차별화된 서비스
                                            </div>
                                            <div className="sitro__desc">
                                                <img src="./images/new-logo.png" alt="new logo" /> 은 구인구직 정보뿐
                                                아니라 개인정보 관리 서비스를 운영함으로써 희망하는 구인, 구직
                                                대상자간의 쪽지 교환 서비스를 제공하는 <span>My 쪽지,</span> 고객이
                                                원하는 채용소식, 인재소식을 My 초이스에 보관하여 나중에 다시 볼 수 있는{' '}
                                                <span>My 초이스,</span> 덴탈잡 이용에 궁금한 사항들을 친절히 상담해주는{' '}
                                                <span> 1:1 친절상담</span>등 고객중심의 편리한 서비스를 제공하고
                                                있습니다.
                                            </div>
                                        </li>
                                        <li className="sitro__item">
                                            <div className="sitro__sbj">
                                                <span className="sitro__num">3</span>
                                                치과인&nbsp;
                                                <span className="sitro__stg">전문 도우미</span>
                                            </div>
                                            <div className="sitro__desc">
                                                <img src="./images/new-logo.png" alt="new logo" /> 은 치과/기공사에서 이용할 수 있는 기본
                                                문서 및 구직자들을 위한 이력서 양식을 제공하는 <span>문서서식,</span>{' '}
                                                이용자들을 위한 다양한 이벤트 등 회원님들을
                                                위한 다양한 서비스를 제공하고 있습니다.
                                            </div>
                                        </li>
                                        <li className="sitro__item">
                                            <div className="sitro__sbj">
                                                <span className="sitro__num">4</span>
                                                최대&nbsp;
                                                <span className="sitro__stg">덴탈</span>
                                                &nbsp;커뮤니케이션
                                            </div>
                                            <div className="sitro__desc">
                                                <img src="./images/new-logo.png" alt="new logo" /> 은 치과, 기공소, 인재
                                                간의 가교 역할을 충실히 수행하는 덴탈 커뮤니케이션 장이 될 수 있도록
                                                항상 새로운 서비스와 다양한 컨텐츠를 끊임없이 창조해 나갈 수 있도록
                                                노력하고 있습니다.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAHAG010;
